import React from 'react';
import { AppBar, Box, Dialog, IconButton, Toolbar, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Colors from '../../library/Colors';

const DASHBOARD_URL = 'https://application.softtouch.eu/jeroen/dashboard/?client=';

/**
 * Standard "Dashboard" of the Web reports card: the external dashboard in a
 * full-page dialog (no top/bottom margin). client = the MySoftTouch api key
 * of the current database - the same value auth substitutes for {hashkey}.
 */
const DashboardModal = (props) => {
    const tx = (key, fallback) => {
        const value = props.t ? props.t(key) : null;
        return value && value !== key ? value : fallback;
    };
    const src = DASHBOARD_URL + encodeURIComponent(props.api || '');
    return (
        <Dialog open={!!props.open} onClose={props.onClose} fullScreen
            PaperProps={{ sx: { m: 0, borderRadius: 0 } }}>
            <AppBar position="static" elevation={0} sx={{ backgroundColor: Colors.sft_blue }}>
                <Toolbar variant="dense" sx={{ minHeight: 44 }}>
                    <Typography variant="subtitle1" sx={{ flex: 1, fontWeight: 600 }}>
                        {tx('webreport_dashboard_title', 'Dashboard')}
                    </Typography>
                    <IconButton edge="end" color="inherit" onClick={props.onClose}
                        aria-label={tx('reports_close', 'Close')}>
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Box sx={{ flex: 1, display: 'flex' }}>
                {props.open && (
                    <iframe title="dashboard" src={src}
                        style={{ flex: 1, width: '100%', height: '100%', border: 0 }} />
                )}
            </Box>
        </Dialog>
    );
};

export default DashboardModal;
